/**
*
* TopicStatus
*
*/

import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'react-bootstrap';
import messages from '../messages.js';
import useConversationsContext from '../useConversationsContext.js';

function TopicStatus() {
  const { topic } = useConversationsContext();
  const { closed, permissions } = topic;

  if (closed) {
    return <Alert className="mt-3" variant="info"><FormattedMessage {...messages.topicClosed} /></Alert>;
  }
  if (!permissions.write) {
    return <Alert className="mt-3" variant="info"><FormattedMessage {...messages.topicNoWrite} /></Alert>;
  }
  return null;
}

export default TopicStatus;
